export const STATUSES = {
  ACTIVE: {
    id: 1,
    title: 'Active',
    code: 'active',
  },
  PAUSE: {
    id: 2,
    title: 'Paused',
    code: 'pause',
  },
  FINISHED: {
    id: 3,
    title: 'Completed',
    code: 'finished',
  },
  STOPPED: {
    id: 4,
    title: 'Canceled',
    code: 'stopped',
  },
  EXPIRED: {
    id: 5,
    title: 'Expired',
    code: 'expired',
  },
  FAIL: {
    id: 6,
    title: 'Fail',
    code: 'fail',
  },
  AWAITING: {
    id: 7,
    title: 'Awaiting',
    code: 'awaiting',
  },
  ERROR: {
    id: 8,
    title: 'Error',
    code: 'error',
  },
}
